export const PROCESS = {
  REGISTER_HV_ECU: {
    NAME: "register_hvecu",
    NUMBER: 22
  },
  DELETE_ALL_KEYS: {
    NAME: "delete_all_keys",
    NUMBER: 23
  }
};

export const FUNCTION_NAME = {
  REGISTER_HVECU: 'Register HVECU',
  DELETE_ALL_KEYS: 'Key Information Reset'
};

export const STATUS = {
  REGISTER_HVECU: 'registering_hvecu'
};

export const IOCP_RCID_ERROR = {
  CODE_MISMATCH_BETWEEN_HVECU_AND_IMB: '04',
  COMM_FAILURE_BETWEEN_HVECU_AND_IMB: '05',
  HVECU_EEPROM_FAILURE: '06',
  IMB_EEPROM_FAILURE: '07'
};

export const IMB_ERROR = {
  NO_RESPONSE_FROM_EGI: 8060,
  HVECU_NO_SECURITY_ACCESS: 8061,
  COMM_FAILURE_BETWEEN_HVECU_AND_SSM: 8062,
  NO_RESPONSE_FROM_HVECU: 8063,
  IMB_NO_REGISTERED_KEY_READ_ERROR: 8070,
  IMB_DELETE_ALL_KEYS_FAILURE_ERROR: 8071,
  IMB_DELETE_ALL_KEYS_CANCELLED_ERROR: 8072,
  IMB_MODE_TRANSITION_ERROR: 8073,
  IMB_EXPIRE_OTPW_ERROR: 8074,
};

export const VEHICLE_TYPE = {
  TYPE1: ['B1'],
  TYPE2: ['B2', 'E', 'G', 'I'],
  TYPE3: ['D', 'H1', 'H2', 'J'],
};

export const API_ENDPOINT = {
  DELETE_ALL_KEY_AUTHENTICATION: '/deleteAllKeyAuthentication/',
  START_DELETE_ALL_KEY2: '/startDeleteAllKey/',
  START_DELETE_ALL_KEY3: '/startDeletionAllKey/',
  DELETE_ALL_KEY_IGON: '/deleteAllKeyIgOn/',
  DELETE_ALL_KEY_CANCEL: '/deleteAllKeyCancel/',
};
